export enum PaymentStatusBookingEnum {
  Draft = 'draft',
  Failed = 'failed_due_to_timeout',
  Pending = 'pending',
  Completed = 'completed',
  RefundProcessing = 'refund_processing',
  Refunded = 'refunded',
  Canceled = 'canceled',
}

export const paymentStatusBookingLocoKeys = {
  [PaymentStatusBookingEnum.Draft]: 'dashboard.calendar.bookings.payment_status_draft',
  [PaymentStatusBookingEnum.Failed]: 'dashboard.calendar.bookings.payment_status_failed',
  [PaymentStatusBookingEnum.Pending]: 'dashboard.calendar.bookings.payment_status_pending',
  [PaymentStatusBookingEnum.Completed]: 'dashboard.calendar.bookings.payment_status_completed',
  [PaymentStatusBookingEnum.RefundProcessing]:
    'dashboard.calendar.bookings.payment_status_refund_processing',
  [PaymentStatusBookingEnum.Refunded]: 'dashboard.calendar.bookings.payment_status_refunded',
  [PaymentStatusBookingEnum.Canceled]: 'dashboard.calendar.bookings.payment_status_сanceled',
}

export const getPaymentStatusBooking = (paymentStatus: PaymentStatusBookingEnum | null) => {
  return paymentStatus
    ? paymentStatusBookingLocoKeys[paymentStatus]
    : 'dashboard.calendar.bookings.payment_status_free'
}
